import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Text } from "@chakra-ui/react";
import { HiOutlineChartBar } from "react-icons/hi2";
import { useAuth } from "@/auth/AuthContext";
import { useAccountScoring } from "@/auth/ScoringContext";
import AccountService from "@/services/AccountService";
import { toaster } from "@/components/ui/toaster";
import { FormSwitch } from "@/components/jobOffer/ui/inputs";
import SectionCard from "./SectionCard";

const ScoringSection = () => {
    const { t } = useTranslation("account");
    const { isOwner } = useAuth();
    const { accountScoringEnabled, setAccountScoringEnabled } = useAccountScoring();
    const [isSaving, setIsSaving] = useState(false);

    const handleChange = async (enabled) => {
        const previous = accountScoringEnabled;
        setAccountScoringEnabled(enabled);
        setIsSaving(true);
        try {
            const result = await AccountService.updateScoring(enabled);
            setAccountScoringEnabled(result?.enabled ?? enabled);
            toaster.create({ type: "success", title: t(enabled ? "settingsPage.scoring.toastOn" : "settingsPage.scoring.toastOff") });
        } catch {
            setAccountScoringEnabled(previous);
            toaster.create({ type: "error", title: t("settingsPage.scoring.toastError") });
        } finally {
            setIsSaving(false);
        }
    };

    return (
        <SectionCard icon={<HiOutlineChartBar />} title={t("settingsPage.scoring.title")} subtitle={t("settingsPage.scoring.subtitle")}>
            <fieldset disabled={!isOwner || isSaving} style={{ border: 0, padding: 0, margin: 0, opacity: isOwner ? 1 : 0.6 }}>
                <FormSwitch
                    label={t("settingsPage.scoring.switchLabel")}
                    description={t("settingsPage.scoring.switchHint")}
                    checked={accountScoringEnabled}
                    onChange={handleChange}
                />
            </fieldset>
            {!isOwner && (
                <Text color="text.grey" fontSize="xs" mt={3}>{t("settingsPage.scoring.ownerOnly")}</Text>
            )}
        </SectionCard>
    );
};

export default ScoringSection;
